import { render, staticRenderFns } from "./char1.vue?vue&type=template&id=564645d8&"
import script from "./char1.vue?vue&type=script&lang=js&"
export * from "./char1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports